import { render, staticRenderFns } from "./SmallBackButton.vue?vue&type=template&id=6bdf08f6&scoped=true&"
import script from "./SmallBackButton.vue?vue&type=script&lang=js&"
export * from "./SmallBackButton.vue?vue&type=script&lang=js&"
import style0 from "./SmallBackButton.vue?vue&type=style&index=0&id=6bdf08f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf08f6",
  null
  
)

export default component.exports